import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiLinkedin, FiFacebook, FiTwitter, FiYoutube, FiX } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const Footer = () => {
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const openTermsModal = (e) => {
    e.preventDefault();
    setShowTermsModal(true);
  };

  const openPrivacyModal = (e) => {
    e.preventDefault();
    setShowPrivacyModal(true);
  };

  const closeModals = () => {
    setShowTermsModal(false);
    setShowPrivacyModal(false);
  };

  return (
    <>
      <footer className="bg-gray-900 text-white">
        <div className="container mx-auto px-4 pt-16 pb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
            {/* Company Info */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Company</h3>
              <p className="text-gray-300 mb-6">
                Snow's Tax & Financial<br />
                144 Linwood Drive<br />
                Paragould AR 72450<br /><br />
                Phone: <a href="tel:18702084089" className="hover:text-blue-400">(870) 208-4089</a><br /><br />
                <a href="mailto:SimeonSnow@afpadvisor.com?subject=You've%20got%20mail!" className="hover:text-blue-400">SimeonSnow@afpadvisor.com</a><br /><br />
                The content on this website & any links provided is developed from sources believed to be providing accurate information.<br /><br />
                The information on this website is not intended as tax, financial, or legal advice. Please consult with applicable professionals for specific information regarding your individual situation. Please call our office with your specific questions.<br /><br />
                The opinions expressed & material provided are for general information, & should not be considered a solicitation for the purchase or sale of any security.
              </p>
            </div>

            {/* Disclosures */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Disclosures</h3>
              <p className="text-gray-300 mb-6">
                Securities offered through <a href="https://www.ausdal.com/" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">Ausdal Financial Partners, Inc.</a>,<br /><br />
                Member <a href="https://finra.org" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">FINRA</a>/<a href="https://www.sipc.org/" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">SIPC.</a> 5187 Utica Ridge Rd., Davenport IA 52807. (563) 326-2064.<br /><br />
                Snow's Tax & Financial and Ausdal Financial Partners, Inc. are separately owned and operated.<br /><br />
                All communication regarding wealth management must go through the email: SimeonSnow@afpadvisor.com or by calling the office at (870) 208-4089. We cannot take any buy/sell orders via email or voicemail, you must call & speak to a representative.<br /><br />
                <a href="https://www.bigtimberwealth.com/files/94730/Ausdal%20Form%20CRS%206-20.pdf" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">Click here</a> to view the AFP Client Relationship Summary (Form CRS) at <a href="https://www.bigtimberwealth.com/files/94730/Ausdal%20Form%20CRS%206-20.pdf" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline">www.ausdal.com</a>.
              </p>
              <div className="flex space-x-6">
                <a href="https://www.sipc.org/" target="_blank" rel="noopener noreferrer">
                  <img src="https://cdn.prod.website-files.com/64d13f6ce094cf9b34b8f52f/64d377d511b98001edd94c96_sipc.png" alt="SIPC Logo" className="h-10 brightness-0 invert" />
                </a>
                <a href="https://brokercheck.finra.org/" target="_blank" rel="noopener noreferrer">
                  <img src="https://cdn.prod.website-files.com/64d13f6ce094cf9b34b8f52f/64d370fcf880bbfb42bc2335_brokercheck.png" alt="BrokerCheck Logo" className="h-10" />
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="flex flex-wrap justify-center md:justify-start gap-6 mb-6 md:mb-0">
                <a href="https://taxresources.netlify.app/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">Resources</a>
                <a href="https://snowsfinancial.kitchen.co/login" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">Tax Client Portal</a>
                <Link to="/wealth-management" onClick={scrollToTop} className="text-gray-300 hover:text-white">Wealth Management</Link>
                <a href="https://u.pcloud.com/#/puplink?code=LahXZpia3beMI72uiBgecSP2na7BxtHMy" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white">Secure File Upload</a>
              </div>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/snowstaxes" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
                  <FiFacebook size={20} />
                </a>
                <a href="#" className="text-gray-400 hover:text-white">
                  <FiTwitter size={20} />
                </a>
                <a href="https://www.linkedin.com/in/simeonsnow/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white">
                  <FiLinkedin size={20} />
                </a>
                <a href="#" className="text-gray-400 hover:text-white">
                  <FiYoutube size={20} />
                </a>
              </div>
            </div>
            <div className="text-center text-gray-400 mt-8">
              <p>Established &copy;2008 Snow's Tax & Financial.</p>
              <div className="flex justify-center space-x-4 mt-2">
                <button onClick={openTermsModal} className="text-gray-400 hover:text-white text-sm underline cursor-pointer">Terms Of Use</button>
                <button onClick={openPrivacyModal} className="text-gray-400 hover:text-white text-sm underline cursor-pointer">Privacy Policy</button>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Terms of Use Modal */}
      <AnimatePresence>
        {showTermsModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={closeModals}>
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              className="bg-white rounded-lg shadow-xl w-full max-w-4xl mx-4 max-h-[90vh] overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex justify-between items-center p-6 border-b border-gray-200">
                <h2 className="text-2xl font-bold text-gray-900">Terms of Use</h2>
                <button onClick={closeModals} className="text-gray-400 hover:text-gray-600">
                  <FiX size={24} />
                </button>
              </div>
              <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
                <div className="prose prose-sm max-w-none text-gray-700">
                  <p className="mb-4"><strong>Last updated: 08/30/2025</strong></p>
                  <p className="mb-4">Welcome to Snow's Tax & Financial Service ("we," "our," or "us"). By accessing or using our website (www.snowstaxservice.us), you agree to be bound by these Terms of Use.</p>

                  <h3 className="text-lg font-semibold mt-6 mb-3">1. Use of Our Services</h3>
                  <p className="mb-4">Our website provides information and tools related to tax preparation, financial planning, and secure document handling. Use of these services does not constitute legal or financial advice unless explicitly stated in a signed engagement agreement.</p>

                  <h3 className="text-lg font-semibold mt-6 mb-3">2. User Responsibilities</h3>
                  <p className="mb-2">You agree to:</p>
                  <ul className="list-disc pl-6 mb-4">
                    <li>Provide accurate and complete information.</li>
                    <li>Use our services only for lawful purposes.</li>
                    <li>Not attempt to reverse engineer, scrape, or misuse any part of our site or systems.</li>
                  </ul>

                  <h3 className="text-lg font-semibold mt-6 mb-3">3. Intellectual Property</h3>
                  <p className="mb-4">All content, branding, workflows, and software are the property of Snow's Tax & Financial Service. You may not reproduce, distribute, or modify any materials without written permission.</p>

                  <h3 className="text-lg font-semibold mt-6 mb-3">4. Third-Party Tools</h3>
                  <p className="mb-4">We may integrate third-party services (e.g., Supabase, Client Portals, Web Tools). We are not responsible for their functionality or privacy practices.</p>

                  <h3 className="text-lg font-semibold mt-6 mb-3">5. Termination</h3>
                  <p className="mb-4">We reserve the right to suspend or terminate access to our services for violations of these terms.</p>

                  <h3 className="text-lg font-semibold mt-6 mb-3">6. Dispute Resolution</h3>
                  <p className="mb-4">These terms are governed by the laws of the State of Arkansas. Any disputes shall be resolved through binding arbitration in Paragould, AR.</p>

                  <h3 className="text-lg font-semibold mt-6 mb-3">7. Changes to Terms</h3>
                  <p className="mb-4">We may update these Terms of Use at any time. Continued use of the site constitutes acceptance of the revised terms.</p>

                  <p className="mb-4">If you have questions, contact us at: <a href="mailto:snows.tax.financial@gmail.com" className="text-blue-600 hover:underline">snows.tax.financial@gmail.com</a></p>
                </div>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      {/* Privacy Policy Modal */}
      <AnimatePresence>
        {showPrivacyModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={closeModals}>
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              className="bg-white rounded-lg shadow-xl w-full max-w-4xl mx-4 max-h-[90vh] overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex justify-between items-center p-6 border-b border-gray-200">
                <h2 className="text-2xl font-bold text-gray-900">Privacy Policy</h2>
                <button onClick={closeModals} className="text-gray-400 hover:text-gray-600">
                  <FiX size={24} />
                </button>
              </div>
              <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
                <div className="prose prose-sm max-w-none text-gray-700">
                  <p className="mb-4"><strong>Last updated: 08/30/2025</strong></p>
                  <p className="mb-4">Snow's Tax & Financial Service ("we," "our," or "us") is committed to protecting your privacy. This policy explains how we collect, use, and safeguard your personal information.</p>

                  <h3 className="text-lg font-semibold mt-6 mb-3">1. Information We Collect</h3>
                  <p className="mb-2">We may collect:</p>
                  <ul className="list-disc pl-6 mb-4">
                    <li>Personal identifiers (name, email, phone number, SSN)</li>
                    <li>Financial documents and tax data</li>
                    <li>IP address and browser metadata</li>
                    <li>Uploaded files and digital signatures</li>
                  </ul>

                  <h3 className="text-lg font-semibold mt-6 mb-3">2. How We Use Your Information</h3>
                  <p className="mb-2">We use your data to:</p>
                  <ul className="list-disc pl-6 mb-4">
                    <li>Provide tax and financial services</li>
                    <li>Communicate with you securely</li>
                    <li>Maintain compliance with IRS and FTC regulations</li>
                  </ul>
                  <p className="mb-4">We do not sell or share your information for marketing purposes or any other purposes.</p>

                  <h3 className="text-lg font-semibold mt-6 mb-3">3. Data Security</h3>
                  <p className="mb-4">We implement encryption, access controls, and secure hosting to protect your data. Our systems align with IRS Publication 1075 and the FTC Safeguards Rule.</p>

                  <h3 className="text-lg font-semibold mt-6 mb-3">4. Third-Party Services</h3>
                  <p className="mb-4">We use trusted vendors (e.g., Supabase for secure data storage, Topaz SDK for signature capture, Client Portals, Web Tools, etc.). These providers may have access to limited data solely for service delivery. We monitor 3rd party service vendors on a continual basis & document our findings within our WISP (Written Information Security Plan).</p>

                  <h3 className="text-lg font-semibold mt-6 mb-3">5. Your Rights</h3>
                  <p className="mb-2">You may request:</p>
                  <ul className="list-disc pl-6 mb-4">
                    <li>Access to your personal data</li>
                    <li>Corrections or updates</li>
                    <li>Deletion of non-essential data</li>
                  </ul>
                  <p className="mb-4">To make a request, email: <a href="mailto:snows.tax.financial@gmail.com" className="text-blue-600 hover:underline">snows.tax.financial@gmail.com</a></p>

                  <h3 className="text-lg font-semibold mt-6 mb-3">6. Cookies & Analytics</h3>
                  <p className="mb-4">We use cookies for session management and analytics. You may opt out via your browser settings.</p>

                  <h3 className="text-lg font-semibold mt-6 mb-3">7. Children's Privacy</h3>
                  <p className="mb-4">Our services are not intended for individuals under the age of 13.</p>

                  <h3 className="text-lg font-semibold mt-6 mb-3">8. Changes to This Policy</h3>
                  <p className="mb-4">We may update this Privacy Policy. Changes will be posted on this page with a revised date.</p>

                  <p className="mb-4">Questions? Contact us at: <a href="mailto:snows.tax.financial@gmail.com" className="text-blue-600 hover:underline">snows.tax.financial@gmail.com</a></p>
                </div>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Footer;